import { MULTIPART_FORM_DATA_TYPE } from '../../services/request/contentTypes'
import { createAuthedApi } from '../../utils/authedApi'
import { applicationSchemas } from './schema'

export const applicationsApiCreator = authRequest => ({
  async allByUserId(userId) {
    const result = await authRequest(`/request/user/${userId}`)

    return applicationSchemas.normalizeResponseList(result)
  },
  async getById(id) {
    const result = await authRequest(`/request/${id}`)

    return applicationSchemas.normalizeResponse(result)
  },
  async step(id, data) {
    const result = await authRequest(`/request/${id}`, {
      method: 'POST',
      body: data
    })

    return applicationSchemas.normalizeResponse(result)
  },
  async create(data) {
    const result = await authRequest(`/request/add/new`, {
      method: 'POST',
      body: data
    })

    return applicationSchemas.normalizeResponse(result)
  },

  // documents
  async getRequiredDocuments(id) {
    const result = await authRequest(`/request/${id}/documents`)

    return result.response
  },
  async requestInfo(id, data) {
    const result = await authRequest(`/request/${id}/info`, {
      method: 'POST',
      body: data
    })

    // wrap with application entity to update all application state
    // instead only document_info entities
    return applicationSchemas.normalize({
      id,
      document_info: result.response
    })
  },
  async checkDocuments(id) {
    const result = await authRequest(`/request/${id}`, {
      method: 'PUT'
    })

    return applicationSchemas.normalize(result.response)
  },

  // uploads
  async postHacienda(id, data) {
    const result = await authRequest(`/request/${id}/hacienda`, {
      method: 'POST',
      body: data
    })

    // wrap with application entity to update all application state
    // instead only documents entities
    return applicationSchemas.normalize({
      id,
      documents: result.response
    })
  },
  async postFile(id, data) {
    const result = await authRequest(`/request/${id}/files`, {
      method: 'POST',
      headers: {
        'Content-Type': MULTIPART_FORM_DATA_TYPE
      },
      body: data
    })

    // wrap with application entity to update all application state
    // instead only documents entities
    return applicationSchemas.normalize({
      id,
      documents: result.response
    })
  }
})

export default createAuthedApi(applicationsApiCreator)
